import React from 'react';
import '../Gallery/Gallery.css';
import img1 from "../../img/img/a1.jpg";
import img2 from "../../img/img/a2.jpg";
import img3 from "../../img/img/a3.jpg";
import img4 from "../../img/img/a4.jpg";
import img5 from "../../img/img/a19.jpg";
import img6 from "../../img/img/a6.jpg";
import img7 from "../../img/img/a7.jpg";
import img8 from "../../img/img/a8.jpg";
import img9 from "../../img/img/a18.jpg";
import img10 from "../../img/img/a10.jpg";
import img11 from "../../img/img/a11.jpg";
import img12 from "../../img/img/a12.jpg";

function Gallery() {
  return (
    <>
      {/* Page heading */}
      <section className="about-section1 d-flex align-items-center">
        <div className="container text-center text-white">
          <h1 className="fw-bold">Gallery</h1>
        </div>
      </section>

      {/* Gallery Grid */}
      <div className="container my-5">
        <div className="gallery">
          <div className="row">

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex flex-column gap-2">
              <div className="zoom-container"><img src={img1} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img2} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img3} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img10} alt="Gallery" /></div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex flex-column gap-2">
              <div className="zoom-container"><img src={img4} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img5} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img9} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img11} alt="Gallery" /></div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex flex-column gap-2">
              <div className="zoom-container"><img src={img6} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img7} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img8} alt="Gallery" /></div>
              <div className="zoom-container"><img src={img12} alt="Gallery" /></div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Gallery;
